/**
 * Firebase app and messaging for push notifications (FCM).
 * Config from .env (REACT_APP_FIREBASE_*) or fallback for taylor-c9674.
 */
import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyA-5_onqkYYVX-OX6GR1j8fphkvv1LKfoA",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "taylor-c9674.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "taylor-c9674",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "taylor-c9674.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "584588216199",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:584588216199:web:e0cc3d7693c1e2e77bf522",
};

let app = null;
let messaging = null;

export function getFirebaseApp() {
  if (app) return app;
  if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
    console.warn("[Firebase] Missing REACT_APP_FIREBASE_* env. Push disabled.");
    return null;
  }
  app = initializeApp(firebaseConfig);
  return app;
}

export async function getFirebaseMessaging() {
  if (messaging) return messaging;
  const supported = await isSupported();
  if (!supported) {
    console.warn("[Firebase] Messaging not supported in this browser.");
    return null;
  }
  const currentApp = getFirebaseApp();
  if (!currentApp) return null;
  messaging = getMessaging(currentApp);
  return messaging;
}

export const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || null;

export default { getFirebaseApp, getFirebaseMessaging, vapidKey };
